import { Box, Skeleton, Stack, Divider } from '@mui/material';
import { styled } from '@mui/material/styles';

const MessageContainer = styled(Box)(({ theme }) => ({
  padding: '16px',
  marginBottom: '12px',
  borderRadius: '12px',
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: '#FFF',
}));

export const CallTranscriptionSkeleton = () => {
  return (
    <Box sx={{ display: 'flex', height: 'calc(100vh - 200px)' }}>
      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Skeleton
          variant="rectangular"
          height={128}
          sx={{
            borderRadius: 2,
            width: '100%',
          }}
        />
        <Box
          sx={{
            flex: 1,
            overflow: 'auto',
            // p: 2,
            '&::-webkit-scrollbar': {
              display: 'none',
            },
            msOverflowStyle: 'none',
            scrollbarWidth: 'none',
          }}
        >
          {[1, 2, 3].map((_, index) => (
            <MessageContainer key={index}>
              <Skeleton width={80} height={20} sx={{ mb: 1 }} />
              <Skeleton height={48} width="100%" />
            </MessageContainer>
          ))}
        </Box>
      </Box>

      <Box
        sx={{
          width: '300px',
          borderLeft: '1px solid #E5E7EB',
          backgroundColor: '#FFF',
          p: 2,
        }}
      >
        <Stack spacing={2} divider={<Divider />}>
          {[
            'Agent Name',
            'Id',
            'From',
            'To',
            'Call Type',
            'Cost',
            'Billed For',
          ].map(label => (
            <Box
              key={label}
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Skeleton width={80} height={20} />
              <Skeleton width={120} height={20} />
            </Box>
          ))}
        </Stack>
      </Box>
    </Box>
  );
};
